import { render, staticRenderFns } from "./FrontHeader.vue?vue&type=template&id=0989e748&scoped=true"
import script from "./FrontHeader.vue?vue&type=script&lang=js"
export * from "./FrontHeader.vue?vue&type=script&lang=js"
import style0 from "./FrontHeader.vue?vue&type=style&index=0&id=0989e748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0989e748",
  null
  
)

export default component.exports